import React from "react";
import { LIBRARIES_THEME } from "./librariesTheme";

/**
 * Embedded Coming Soon card for a Libraries sub-module.
 * Does not wrap PAGE_SHELL — lives inside LibrariesModule content pane.
 */
const LibrariesComingSoon = ({ section }) => {
  const Icon = section?.icon;
  return (
    <section
      className={`bg-white rounded-xl border shadow-sm overflow-hidden ${LIBRARIES_THEME.section.wrap}`}
    >
      <div
        className={`flex items-center gap-2 h-11 px-4 border-b box-border ${LIBRARIES_THEME.section.head}`}
      >
        <span
          className={`w-0.5 h-4 rounded-full shrink-0 ${LIBRARIES_THEME.section.bar}`}
          aria-hidden
        />
        {Icon ? (
          <span className={`shrink-0 ${LIBRARIES_THEME.section.icon}`}>
            <Icon size={14} />
          </span>
        ) : null}
        <h2
          className={`min-w-0 flex-1 text-xs font-semibold uppercase tracking-wide truncate ${LIBRARIES_THEME.section.title}`}
        >
          {section?.label || "Libraries"}
        </h2>
        <span
          className={`inline-flex items-center h-5 px-2 rounded text-[10px] font-semibold uppercase tracking-wide shrink-0 ${LIBRARIES_THEME.section.badge}`}
        >
          Coming Soon
        </span>
      </div>

      <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
        {Icon ? (
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-600">
            <Icon size={24} />
          </span>
        ) : null}
        <div className="space-y-1">
          <p className="text-base font-semibold text-slate-800">
            {section?.label || "Section"} is on the way
          </p>
          <p className="text-sm text-slate-500 max-w-md mx-auto leading-relaxed">
            {section?.description ||
              "This tenant-scoped library section will be built next."}
          </p>
        </div>
        <span className="inline-flex items-center h-6 px-2.5 rounded-full text-[11px] font-medium bg-blue-50 text-blue-700 border border-blue-100">
          Admin &amp; OA · tenant scoped
        </span>
      </div>
    </section>
  );
};

export default LibrariesComingSoon;
